var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayedDeliveries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 74,
    viewBox: "0 0 86 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delayed deliveries"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250559",
    d: "M58.3333 0V32.8667H86V58H3V0H58.3333Z",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250560",
    d: "M84 35.2857L74.1626 16H59V43",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 676",
    d: "M32.5 64.5C32.5 69.4467 28.2712 73.5 23 73.5C17.7288 73.5 13.5 69.4467 13.5 64.5C13.5 59.5533 17.7288 55.5 23 55.5C28.2712 55.5 32.5 59.5533 32.5 64.5Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 677",
    d: "M77.5 64.5C77.5 69.4467 73.2712 73.5 68 73.5C62.7288 73.5 58.5 69.4467 58.5 64.5C58.5 59.5533 62.7288 55.5 68 55.5C73.2712 55.5 77.5 59.5533 77.5 64.5Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250562",
    d: "M1 10H41",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250563",
    d: "M1 18L23 18",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250564",
    d: "M1 25L11 25",
    stroke: "#383434",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedDeliveries);
export default __webpack_public_path__ + "static/media/delayed-deliveries.dfac359202510f58e9d6002afef7192b.svg";
export { ForwardRef as ReactComponent };